import { render, staticRenderFns } from "./ReinitializationPassword.vue?vue&type=template&id=16da0e00&scoped=true&"
import script from "./ReinitializationPassword.vue?vue&type=script&lang=js&"
export * from "./ReinitializationPassword.vue?vue&type=script&lang=js&"
import style0 from "./ReinitializationPassword.vue?vue&type=style&index=0&id=16da0e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16da0e00",
  null
  
)

export default component.exports